import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }

import { computed, type Component } from "vue";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { toggleOffcanvas } from "@/utils/Helper";
import { closeOffCanvas, OffcanvasViewKey, OffcanvasViewsConfig, Views } from "./OffcanvasViewsConfig";


export default /*@__PURE__*/_defineComponent({
  __name: 'OffcanvasViews',
  setup(__props) {

const store = useOffcanvasStore();

const View = computed<Component | null>(
  () => Views[store.config?.path as OffcanvasViewKey] || null,
);
const viewProps = computed(() => store.config?.props ?? null);
// título da configuração atual: um painel salvo antes (localStorage) não mostra um título antigo.
// Título que depende do conteúdo ("Depoimentos de …") vai em props.title.
const title = computed(
  () =>
    store.config?.props?.title ??
    OffcanvasViewsConfig[store.config?.path as OffcanvasViewKey]?.title ??
    store.config?.title ??
    "",
);

function offcanvasClosed() {
  if (store.history.length === 1) {
    toggleOffcanvas("offcanvas_views");
    setTimeout(() => {
      store.clear();
    }, 200);
  } else {
    store.popHistory();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_OffcanvasComponent = _resolveComponent("OffcanvasComponent")!

  return (_openBlock(), _createBlock(_component_OffcanvasComponent, {
    id: `offcanvas_views`,
    title: title.value,
    showClose: _unref(store).history.length > 1,
    onOffcanvasClosed: offcanvasClosed,
    onOffcanvasDismissed: _unref(closeOffCanvas)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(View.value), _normalizeProps(_guardReactiveProps(viewProps.value)), null, 16))
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "offcanvas-footer",
        id: "offcanvas_views_footer"
      }, null, -1))
    ]),
    _: 1
  }, 8, ["title", "showClose", "onOffcanvasDismissed"]))
}
}

})